"use client";
import React from "react";
import gs from "gstyles";
import { Image, DropdownView, Icon, Badge } from "components/common";
import { map, isEmpty, get, isEqual } from "utils/lodash";
import { useAuthStore, useShopStore } from "stores";
import { formatPrice } from "utils/currencyFormatter";
import { Store } from "lucide-react";
import { useRouter } from "next/navigation";

export default function ShopInfo({ monthlyRevenue, month }: any) {
  const { user } = useAuthStore();
  const { shopStaff, shop, onChangeShop } = useShopStore();
  const router = useRouter();
  const [shopDropdown, $shopDropdown] = React.useState(false);

  const shops = map(shopStaff, "shop");

  const handleChatClick = () => {
    // Navigate to chat page
    router.push("/chat");
  };

  return (
    <div className="flex items-start justify-between w-full p-4 pb-0 relative">
      <div className="flex w-full items-start gap-3">
        <Image
          wrapClassName="w-10 h-10 rounded-md overflow-hidden flex-shrink-0"
          src={get(shop, "avatar.url") || get(shop, "avatar") || ""}
          defaultImage={<Store size={20} className="text-gray-400" />}
          alt={shop?.name || "Shop"}
          onClick={() => $shopDropdown(!shopDropdown)}
        />

        <div className="flex flex-col gap-1">
          <div
            className="flex items-center gap-1"
            onClick={() => $shopDropdown(!shopDropdown)}
          >
            <label>{get(shop, "name") || "Cửa hàng"}</label>
            <Icon
              name="arrow-down"
              size={16}
              style={{
                transform: shopDropdown ? "rotateX(180deg)" : "rotateX(0deg)",
                transition: "transform 0.1s ease",
              }}
            />
          </div>
          <div className="flex items-center gap-2">
            <label className="text-xs">Doanh thu Th{month}</label>
            <span className="text-xs">{formatPrice(get(monthlyRevenue, "totalRevenue"))}</span>
            {gs.icons({ name: "details", size: 16 })}
          </div>
        </div>
      </div>
      <div className="cursor-pointer transition-transform hover:scale-110" onClick={handleChatClick}>
        <Badge
          type="antd"
          offset={[-3.5, 3.5]}
          dot={!isEqual(get(user, "unreadNotifications"), 0)}
        >
          {gs.icons({ name: "message-active", size: 22 })}
        </Badge>
      </div>
      <DropdownView active={shopDropdown} distance={10}>
        <div className="bg-white rounded-lg shadow-lg" key="dropdown_view">
          {map(shops, (shop, index) => {
            return (
              <div
                className="flex items-center gap-2 p-2 hover:bg-gray-50 cursor-pointer"
                key={`shop-${index}-${shop?.id || 'no-id'}`}
                onClick={() => {
                  onChangeShop(shop);
                  $shopDropdown(false);
                }}
              >
                <Image
                  wrapClassName="w-10 h-10 rounded-md overflow-hidden flex-shrink-0"
                  src={get(shop, "avatar.url") || get(shop, "avatar") || ""}
                  defaultImage={<Store size={20} className="text-gray-400" />}
                  alt={shop?.name || "Shop"}
                />
                <span>{shop?.name || "Cửa hàng"}</span>
              </div>
            );
          })}
        </div>
      </DropdownView>
    </div>
  );
}
